import React from "react";
import { useAuth } from "../context/AuthContext";
import { LOGOS, STATUS_COLORS } from "../lib/api";
import { LogOut, Paperclip } from "lucide-react";

export const StatusBadge = ({ status }) => (
  <span
    className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap"
    style={{ backgroundColor: `${STATUS_COLORS[status]}22`, color: STATUS_COLORS[status] }}
  >
    <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: STATUS_COLORS[status] }} />
    {status}
  </span>
);

// Dark-theme supporting attachment buttons (Manager / Worker / Review portals).
export const AttachmentList = ({ attachments, onView, label = "Supporting Attachments" }) => {
  if (!attachments || attachments.length === 0) return null;
  return (
    <div data-testid="attachment-list">
      <p className="text-xs uppercase tracking-wider text-[#9CA3AF] mb-2">{label}</p>
      <div className="flex flex-wrap gap-2">
        {attachments.map((a) => (
          <button
            key={a.id}
            data-testid={`attachment-${a.id}`}
            onClick={() => onView({ file: a, title: a.display_name || a.filename })}
            className="flex items-center gap-1.5 text-sm font-medium px-3 py-2 rounded-lg text-white border transition-colors hover:border-[#F97316]"
            style={{ borderColor: "#1E3A8A", backgroundColor: "#0A1F44" }}
          >
            <Paperclip size={14} style={{ color: "#F97316" }} />
            {a.display_name || a.filename}
          </button>
        ))}
      </div>
    </div>
  );
};

export const NewBadge = ({ testId }) => (
  <span data-testid={testId} className="text-[10px] font-extrabold tracking-wide px-2 py-0.5 rounded-full flex-shrink-0"
    style={{ backgroundColor: "#7C3AED", color: "#fff" }}>NEW!</span>
);

export const DarkPortalShell = ({ subtitle, headerExtra, children }) => {
  const { auth, logout } = useAuth();
  return (
    <div className="min-h-screen" style={{ backgroundColor: "#0A1F44" }}>
      <header className="border-b sticky top-0 z-30" style={{ borderColor: "#1E3A8A", backgroundColor: "#0A1F44" }}>
        <div className="max-w-6xl mx-auto px-5 py-5 flex items-center justify-between">
          <div className="flex items-center gap-4 min-w-0">
            <img src={LOGOS.whiteWordmark} alt="360 Safety Systems" className="h-14 sm:h-16 w-auto" />
            <div className="h-10 w-px bg-[#1E3A8A] hidden sm:block" />
            <div className="hidden sm:block min-w-0">
              <p className="text-white font-heading font-semibold leading-tight truncate">{auth.client_name}</p>
              <p className="text-[#9CA3AF] text-xs">{subtitle}</p>
            </div>
          </div>
          <div className="flex items-center gap-1">
          {headerExtra}
          <button
            data-testid="logout-button"
            onClick={logout}
            className="flex items-center gap-2 text-sm text-[#9CA3AF] hover:text-white transition-colors px-3 py-2 rounded-lg hover:bg-white/5"
          >
            <LogOut size={16} /> <span className="hidden sm:inline">Log out</span>
          </button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-5 py-8 fade-up">{children}</main>
    </div>
  );
};
